<nav class="navbar bg-dark navbar-expand-lg border-body sticky-top" data-bs-theme="dark">
  <div class="container-fluid">
      <a class="navbar-brand d-flex align-items-center" href="#">
          <img src="assets/images/logo.svg" alt="logo" class="logo">
      </a>
      <button class="navbar-toggler" type="button" (click)="isMenuCollapsed = !isMenuCollapsed"
          [attr.aria-expanded]="!isMenuCollapsed" aria-controls="navbarSupportedContent" aria-label="Toggle navigation">
          <span class="navbar-toggler-icon"></span>
      </button>
      <div class="navbar-collapse" [ngbCollapse]="isMenuCollapsed" id="navbarSupportedContent">
          <ul class="navbar-nav ms-auto align-items-center">
              <li class="nav-item">
                  <a class="nav-link" routerLink="/user/list" routerLinkActive="active" (click)="isMenuCollapsed = true">Users</a>
              </li>
              <li class="nav-item">
                  <a class="nav-link" routerLink="/user/invite" routerLinkActive="active" (click)="isMenuCollapsed = true">Invite User</a>
              </li>
              <!-- Mobile: Show logout link -->
              <li class="nav-item d-lg-none">
                  <a class="nav-link" (click)="logout()">
                      <i class="bi bi-box-arrow-right"></i> Logout
                  </a>
              </li>
              <!-- Desktop: Show profile dropdown -->
              <li class="nav-item profile d-none d-lg-block" ngbDropdown #profileDropdown="ngbDropdown" display="dynamic" placement="bottom-end">
                  <button type="button" class="nav-link dropdown-toggle d-flex align-items-center gap-2"
                      id="dropdownProfile" ngbDropdownToggle>
                      <i class="bi bi-person-circle icon"></i>
                  </button>
                  <div ngbDropdownMenu aria-labelledby="dropdownProfile">
                      <span ngbDropdownItem>{{ userName }}</span>
                      <button ngbDropdownItem (click)="logout()"><i class="bi bi-box-arrow-right"></i>Logout</button>
                  </div>
              </li>
          </ul>
      </div>
  </div>
</nav>
